exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my-ul li{margin-left:24px;color:#22252c;font-size:1.4rem;line-height:1.4\n}", ""]);

// exports
